import { genericRequest } from "./genericRequest";

export const getUsers = async (id) => {

  return await genericRequest(
    `https://users.ponzilover.com/api/users/${id}`
  );
};
